import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getGalleriesList } from '../../modules/selectors';
import { multipleGalleryUpdate } from '../../modules/actions';
import { useCollectionSettingsFieldUpdate } from './useCollectionSettingsFieldUpdate';
import { areAllGalleriesDownloadable } from './galleriesGlobalState';

export const useSettingsGlobalDownload = () => {
  const dispatch = useDispatch();
  const galleries = useSelector(getGalleriesList);
  const { changeFormHandler } = useCollectionSettingsFieldUpdate();
  const turnOnDownload = areAllGalleriesDownloadable(galleries);

  // keep the global switch in sync with the per-album flags
  useEffect(() => {
    if (galleries.length) {
      changeFormHandler('globalDownloadState', turnOnDownload);
    }
  }, [turnOnDownload, galleries]); // eslint-disable-line

  const changeDownload = useCallback(
    (value: boolean) => {
      changeFormHandler('globalDownloadState', value);
      dispatch(
        multipleGalleryUpdate({
          download: value
        })
      );
    },
    [dispatch, changeFormHandler]
  );

  return { changeDownload };
};
